import { TableSettingsType } from "../ObjTableSettingsTypes";

export const titleSettingsMap: Record<TableSettingsType, string> = {
  entities: "Отображение в списке экземпляров (вид по умолчанию)",
  childObjectId: "Отображение на карточке экземпляра (вид по умолчанию)",
  valueObjectId: "Отображение при выборе экземпляра (вид по умолчанию)",
};
